import { Action } from 'redux';
import { IDataSourceDetailInfo } from '../../../ts/models/IDataSourceInfo';
import { IRemoteRefreshScheduleInfo } from '../../../ts/models/IRemoteRefreshScheduleInfo';
import { DeleteRemoteExtractRefresh } from '../AppActionTypes';

export interface DeleteRemoteExtractRefreshAction extends Action {
  schedules: IRemoteRefreshScheduleInfo[];
}

export function deleteRemoteExtractRefresh(
  schedules: IRemoteRefreshScheduleInfo[]
): DeleteRemoteExtractRefreshAction {
  return {
    type: DeleteRemoteExtractRefresh,
    schedules,
  };
}
